const kpiManagementRoute = {
    BASE_PATH: "/kpi-management",
    addPath: function() {
        return this.BASE_PATH + "/create"
    },
    editPath: function(kpiId: number | string) {
        return `${this.BASE_PATH}/${kpiId}/edit`
    }
}

export default kpiManagementRoute;